export default __webpack_public_path__ + "static/media/avatar_80.e361e2e4.png";